import styles from './styles.module.css';
import InfographicsIcon from './infographicsIcon.svg';
import DownIcon from './downIcon.svg';
import { useEffect, useRef, useState } from 'react';
import { css } from '@emotion/react';
import { Radio } from '@mui/material';
import PrimaryButton, {
    ButtonTypes,
} from '@/modules/ui-elements/PrimaryButton';
import { entitiesCreatedByUserV4, moveUserToAnotherEntity } from '../services/Entity';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import useAuth from '@/hooks/useAuth';
import { debounce , compact } from "lodash";
import PrimaryInput, { PrimaryInputSizes, PrimaryInputTypes } from "src/modules/ui-elements/PrimaryInput";
import SecondaryButton from '@/modules/ui-elements/SecondaryButton/index';
import { ICONS } from '@/modules/ui-elements/Icon';
import useToast from '@/hooks/useToast';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { standardInfographic, activePageAtom, entitySwitchedAtom } from 'src/modules/editor-v2/Atoms';
import { useSelector } from "react-redux";
import CustomizedButton from '@/modules/ui-elements/CustomizedButton';

const INTERNAL_INFOGRAPHIC_ENTITY = process.env.NEXT_PUBLIC_INFOGRAPHIC_ENTITY;

export function InfographicsSelector() {
    const [isOpen, setIsOpen] = useState(false);
    const setIsStandard = useSetAtom(standardInfographic);
    const isStandard = useAtomValue(standardInfographic);
    const [isLoading, setLoading] = useState(false);
    const [searchCompanyName, setSearchCompanyName] = useState("");
    const [entityId, setEntityId] = useState("");
    const { user, refreshUserDetails } = useAuth();
    const toaster = useToast();
    const [page, setpage] = useAtom(activePageAtom);
    const setSwitchEntity = useSetAtom(entitySwitchedAtom);
    const [updatedUser, setUpdatedUser] = useState('');
    const { entireStrapiData } = useSelector((state) => state.strapi)
    const strapiData = entireStrapiData?.WebappHomepageV22?.WebappHomepageV22;
   
    useEffect (()=>{
            user?.entity?.entity?._id != INTERNAL_INFOGRAPHIC_ENTITY ? setIsStandard(false): setIsStandard(true);
        }
    ,[user,updatedUser])

    const onCreate= async()=>{
        if(isStandard && user?.entity?.entity?._id == INTERNAL_INFOGRAPHIC_ENTITY) {
            setSearchCompanyName('');
            setIsOpen(false);
            setSwitchEntity(true);
            return;
        }
        else if(!isStandard && !entityId){
            toaster.error("Please select a user");
            return;
        }
        setLoading(true);
        try
        {
            const res =  await moveUserToAnotherEntity(isStandard ? INTERNAL_INFOGRAPHIC_ENTITY : entityId);
            setLoading(false);
            {res?.success ? toaster.success(strapiData?.MergeUserSuccess || "User merged successfully") : toaster.error(res?.message)}
            const result = await refreshUserDetails();
            setUpdatedUser(result);
            setIsOpen(false);
            setSwitchEntity(true);
        }catch(e){
            console.log("error is",e)
        }
        finally{
            setLoading(false);
            setSearchCompanyName('');
        }
    }
      const onSearchInputChange = useCallback((e)=>{
          setSearchCompanyName(e.target.value);
      },[setSearchCompanyName]);
      const {status,  data, isFetchingNextPage, hasNextPage, fetchNextPage} = useInfiniteQuery({
          queryKey: ["entityList", "infinite", searchCompanyName],
          getNextPageParam: (lastPage, pages) =>(lastPage?.length >= 5)?pages.length:undefined,
         queryFn: ({pageParam}) =>entitiesCreatedByUserV4(user?.user?._id, pageParam, searchCompanyName, "DoMyShoot"),
      })
      
      const onCancel= ()=>{setIsOpen(false);setSearchCompanyName('');user?.entity?.entity?._id != INTERNAL_INFOGRAPHIC_ENTITY ? setIsStandard(false): setIsStandard(true);}

      const buffer = useRef(50);
      const onScroll = debounce((e) => {
          if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - buffer.current) {
              if (!isFetchingNextPage) fetchNextPage();
          }
      }, 100);

      const standardUserChange = ()=>{
        setIsStandard(true);
      }
      
      const dropDownView = () =>{
        if(page == undefined) 
        { 
            setIsOpen(!isOpen)
        }
        else{
            toaster.error(strapiData?.switchUserAlert || "Cannot switch user after creating a project")
        }
      }

      useEffect(()=>{setIsOpen(false)},[page])
      
    return (<div><div className={`${styles["infographic-selector-container"]} user-selection-disable`} onClick={dropDownView}>
        <CustomizedButton
        type='grey'
        btnText={`${strapiData?.CreateInfographic || "Select Entity"}: ${user?.entity?.entity?._id == INTERNAL_INFOGRAPHIC_ENTITY ? "Standard": user?.entity?.entity?.company_name}`}
        endIcon={ICONS?.dropArrow}
        btnStyle={styles2?.btnStyle}
        />
    </div>
        {isOpen && <div css={styles2.backgroundListContainer}>
            <div css={{ ...styles2.heading }}>
               {strapiData?.CreateInfographic || "Select Entity"}
            </div>
            <div css={{ ...styles2.heading2 }}>
                {strapiData?.InfographicType ||"Entity Type"}
            </div>
            <div css={styles2.backgroundListAll} onClick={standardUserChange}>
                <Radio
                    checked={isStandard}
                    size="small"
                    sx={styles2.backgroundListCheckbox}
                />
                <div css={styles2.subtitle}>
                    <div><b>{strapiData?.StandardText ||"Standard"}</b></div>
                    <div>{strapiData?.StandardDescription ||"Create standard infographics and publish in entity ProDesign Internal"}</div>
                </div>
            </div>
            <div>
            <div css={styles2.backgroundListAll} onClick={() => { setIsStandard(false) }}>
                <Radio
                    checked={!isStandard}
                    size="small"
                    sx={styles2.backgroundListCheckbox}
                />
                <div css={styles2.subtitle}>
                    <div><b>{strapiData?.CustomText ||"Custom"}</b></div>
                    <div>{strapiData?.CustomDescription ||"Create custom infographics, create jobs, access projects in customer’s entity"}</div>
                </div>
            </div>
            {!isStandard && <div css={styles2.list2}>
            <div  >
                    <PrimaryInput size={PrimaryInputSizes.xl} type={PrimaryInputTypes.grey} endIcon={"/icons/search-dark.svg"} value={searchCompanyName} placeholder={"Search by entity name or entity id"} onChange={onSearchInputChange} />
            </div>
            <div onScroll={onScroll}>
                {(status === "loading") && <div style={styles2.loadingContainer}>
                   {strapiData?.LoadingText ||" Loading...."}
                </div>}
                <div style={styles2.messageContainer2}>{data?.pages[0]?.data.length == 0  ? <>{strapiData?.NotFound || "Not Found"}</> : <></>}</div>
                {compact(data?.pages.flatMap(x => x.data)).map((entity) => {
  return <SecondaryButton type={"black-bg-grey"} style={styles2.dropDown} title={entity.company_name} disabled={entity._id === entityId} onClick={()=>{setEntityId(entity._id);}} rightIcon={entity._id === entityId ? ICONS.tickIcon : null}/>;
                })}
                {isFetchingNextPage && <div style={styles2.messageContainer2}>
                   {strapiData?.LoadingText ||" Loading...."}
                </div>}
            </div>
        </div>}
            </div>
            
            <div style={styles2.footer}>
                <PrimaryButton
                    type={ButtonTypes.light}
                    text={strapiData?.CancelText ||"Cancel"}
                    onClick={onCancel}
                    style={styles2.button3}
                />
                <PrimaryButton
                    type={ButtonTypes.darkBgWhiteText}
                    text={strapiData?.CreateText ||"Switch Entity"}
                    style={styles2.button2}
                    isLoading={isLoading}
                    onClick={onCreate}
                />
            </div>
        </div>}
    </div>)
}
const styles2 = {
    backgroundListContainer: css`
    position: absolute;
    top: 57px;
    left: 82px;
    width: 100%;
    max-width: 350px;
    background: #fff;
    z-index: 10;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: -3px 0px 32px 0px rgba(38, 38, 38, 0.24);
    z-index: 9999
  `,
  btnStyle:css`
    font-family: Objectivity;
    font-size: 12px;
    font-weight: 400;
    line-height: 20.4px;
  `,
    heading: css`
    border-bottom: 0.5px solid rgba(238, 238, 238, 1);
    width: 100%;
    display: flex;
    font-family: Objectivity;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    padding: 16px 14px;
  `,
    heading2: css`
    font-family: Objectivity;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    width: 100%;
    display: flex;
    padding: 16px 14px;
    `,
    backgroundListAll: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0px 5px 12px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 14px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin: 5px 14px;
    padding: 5px 0px;
  `,
    list: css`
    display: flex;
    align-items: center;
    padding: 5px 0px 5px 12px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 14px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin: 5px 14px;
    padding: 5px 0px;
  `,
  list2: css`${styles.list}; 
  align-items: center;
  padding: 5px 0px 5px 12px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid rgba(238, 238, 238, 1);
  margin: 5px 14px;
  overflow: auto;
  max-height: 150px;
  padding: 5px 0px;`,
    subtitle: css`
    font-family: Objectivity;
    font-size: 12px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
    gap: 5px;
    display: flex;
    flex-direction: column;
    `,
    backgroundListCheckbox: {
        color: "#262626",
        "&:hover": { backgroundColor: "transparent" },
        "&.Mui-checked": {
            color: "#262626",
        },
        "&.Mui-checked:hover": {
            backgroundColor: "transparent",
        },
    },
    footer: {
        display: "flex",
        padding: "16px 14px",
        width: "100%",
        justifyContent: "space-between",

    },
    searchContainer: {
        background:"#262626", 
        // padding:"8px 10px", 
        display:"flex",
        border: "0.5px solid rgba(238, 238, 238, 0.24)",
        borderRadius: "4px 4px 0px 0px",

    },
    listContainer: {
        padding:"4px 6px", 
        flex:1, 
        display:"flex", 
        background:"#262626", 
        flexDirection:"column", 
        overflow:'auto',
        border: "0.5px solid rgba(238, 238, 238, 0.24)",
        borderRadius: "0px 0px 4px 4px",
        borderTop: "0px",

    },
    loadingContainer: {
        display:"flex", 
        justifyContent:"center", 
        alignItems:"center", 
        height:"100%",
        color:"white",
    },
    messageContainer: {
        display:"flex", 
        justifyContent:"center", 
        alignItems:"center",
        color:'white'
    },
    messageContainer2: {
        display:"flex", 
        marginTop:"10px",
        justifyContent:"center", 
        alignItems:"center",
        color:'grey'
    },
    dropDown:{margin: "7px", padding: "5px", cursor:"pointer"},
    button2:{ width: "75%", padding: "0px 24px", justifyContent: "center" },
    button3:{ padding: "10px 14px", background: "rgba(238, 238, 238, 1)" }
}